export default {
      id: "respect-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#respect",
      toString: function () {
        return this.url;
      }
    }